import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.socialMarketPartners,
    (state) => state
)

export const selectSocialMarketPartners = createSelector(
    baseSelector,
    (state) => state.partners
)

export const selectSocialMarketPartnersFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectSocialMarketPartnersLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectSocialMarketPartnersSearchQuery = createSelector(
    baseSelector,
    (state) => state.searchQuery
)